// src/layouts/MainLayout.jsx
import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import styles from './MainLayout.module.css'; // Create this CSS file

const MainLayout = () => {
    return (
        // This div needs to be a flex column and grow to fill space given by #root
        <div className={styles.mainLayoutWrapper}>
            <Navbar />
            {/* This <main> tag will now correctly grow within mainLayoutWrapper */}
            <main className={styles.contentArea}>
                <Outlet />
            </main>
            <Footer />
        </div>
    );
};

export default MainLayout;